/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsSessionListItem,
    MelcoFusionModelsSessionListItemFromJSON,
    MelcoFusionModelsSessionListItemFromJSONTyped,
    MelcoFusionModelsSessionListItemToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoFusionModelsSessionListItem
 */
export interface MelcoModelsGenericList1MelcoFusionModelsSessionListItem {
    /**
     * 
     * @type {Array<MelcoFusionModelsSessionListItem>}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsSessionListItem
     */
    list: Array<MelcoFusionModelsSessionListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsSessionListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoFusionModelsSessionListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoFusionModelsSessionListItemFromJSON(json: any): MelcoModelsGenericList1MelcoFusionModelsSessionListItem {
    return MelcoModelsGenericList1MelcoFusionModelsSessionListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoFusionModelsSessionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoFusionModelsSessionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoFusionModelsSessionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoFusionModelsSessionListItemToJSON(value?: MelcoModelsGenericList1MelcoFusionModelsSessionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoFusionModelsSessionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


